import { Input } from "baseui/input";
import { ICO2Rate } from "./types";
import { FormattedMessage } from "react-intl";
import { FormControl } from "baseui/form-control";
import { useEffect, useState } from "react";
import { IsGreateEqual, IsGreateThan, MinStringLength } from "../../../utils/validations";

export interface CO2RateState extends ICO2Rate {
    isValid: boolean
}
interface CO2RateStateExt extends CO2RateState {
    isValidValue: boolean
    isValidName: boolean
}
interface CO2RateEditProps extends ICO2Rate {
    onChange: (newState: CO2RateState) => void
}

const CO2RateEditForm = (props: CO2RateEditProps) => {

    const [state, setState] = useState<CO2RateStateExt>({
        ...props,
        isValid: MinStringLength(props.name, 3) && IsGreateEqual(props.valuePerUnit, 0),
        isValidValue: true,
        isValidName: true
    });

    const onNameChanged = (e: any) => {
        setState(prevState => {
            return {
                ...prevState,
                name: e.target.value,
                isValid: MinStringLength(e.target.value, 3) && IsGreateEqual(prevState.valuePerUnit, 0),
                isValidName: MinStringLength(e.target.value, 3)
            }
        });
    };
    const onValuePerUnitChanged = (e: any) => {
        setState(prevState => {
            const value = parseFloat(e.target.value);
            return {
                ...prevState,
                valuePerUnit: value,
                isValid: MinStringLength(prevState.name, 3) && IsGreateEqual(value, 0),
                isValidValue: IsGreateThan(value, 0)
            }
        });
       
    };

    useEffect(() => props.onChange(state), [state])

    return (
        <>
            <FormControl
                label={() => <FormattedMessage id="RateEdit.name" defaultMessage="Name" />}
                caption={() => <FormattedMessage id="RateEdit.namedescripion" defaultMessage="Enter a name" />}
            >
                <Input
                    value={state.name}
                    onChange={onNameChanged}
                    placeholder="..."
                    error={!state.isValidName}
                />
            </FormControl>
            <FormControl
                label={<FormattedMessage id="Devices.CO2perUnit" defaultMessage="CO2 per Unit:" />}
                caption={<FormattedMessage id="Devices.TextCO2perUnit" defaultMessage="Example values -> Current: 0.28 kg/kWh, Heat: 0.311 kg/kWh, Cold: 0.401 kg/kWh, Gas: 2.720 kg/m³, Fuel: 3140 kg/m³, Water: 0.6 kg/m³" />}
            >
                <Input
                    value={state.valuePerUnit}
                    onChange={onValuePerUnitChanged}
                    placeholder="e.g. 0.28"
                    clearOnEscape
                    type="number"
                    endEnhancer={() => <>kg/Unit</>}></Input>
            </FormControl>
        </>
    )
}

export default CO2RateEditForm;



